import { useRef, useState } from 'react';
import { CreatorChallenge } from '../../../../types/challenges';
import ClaimRewardModal from '../ClaimRewardModal/ClaimRewardModal';
import ActiveChallengesList, { ChallengesRefetchHandle } from './ActiveChallengesList';
import ChallengeTabs, { AllChallengesTab } from './ChallengeTabs';
import CompletedChallenges from './CompletedChallenges';
import styles from './allChallenges.module.css';

type AllChallengesContentProps = {
  defaultCurrency: string;
  address: any;
  brandName?: string;
  onClaimed?: () => void;
  onClaimReward?: (challenge: CreatorChallenge) => void;
};

export default function AllChallengesContent({
  defaultCurrency,
  address,
  brandName,
  onClaimed,
  onClaimReward,
}: AllChallengesContentProps) {
  const [activeTab, setActiveTab] = useState<AllChallengesTab>('active');
  const [claimChallenge, setClaimChallenge] = useState<CreatorChallenge | null>(null);
  const activeRef = useRef<ChallengesRefetchHandle>(null);
  const completedRef = useRef<ChallengesRefetchHandle>(null);

  const handleClaimed = () => {
    setClaimChallenge(null);
    activeRef.current?.refetch();
    completedRef.current?.refetch();
    onClaimed?.();
  };

  return (
    <>
      <div className={`${styles.body} ${activeTab === 'completed' ? styles.bodyCompleted : ''}`}>
        <ChallengeTabs activeTab={activeTab} onTabChange={setActiveTab} />
        <div className={activeTab === 'active' ? styles.panel : styles.panelHidden}>
          <ActiveChallengesList
            ref={activeRef}
            defaultCurrency={defaultCurrency}
            brandName={brandName}
            onClaimReward={setClaimChallenge}
          />
        </div>
        <div className={activeTab === 'completed' ? styles.panel : styles.panelHidden}>
          <CompletedChallenges
            ref={completedRef}
            defaultCurrency={defaultCurrency}
            onClaimReward={onClaimReward ?? setClaimChallenge}
          />
        </div>
      </div>

      {claimChallenge?.reviewId && (
        <ClaimRewardModal
          open={Boolean(claimChallenge)}
          reviewId={claimChallenge.reviewId}
          address={address}
          onClose={() => setClaimChallenge(null)}
          onClaimed={handleClaimed}
        />
      )}
    </>
  );
}
